import {mapActions, mapGetters, mapMutations} from 'vuex';
import {camelCase} from 'lodash';
import notice from '@/components/features/notice/index.vue';
import ModuleNavigations from '../module-navigations/index.vue';

export default {
    name: 'lesson-tabs',
    components: {
        notice,
        ModuleNavigations
    },
    props: {
        isLesson: {
            type: Boolean,
            default: false
        },
        isBonus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            active: this.isLesson || this.isBonus ? 1 : 2,
            offsetTopTabs: 0,
            isMobile: false
        };
    },
    watch: {
        '$route.fullPath'() {
            if (this.isLesson) {
                this.fetchLesson({
                    item: this.$route.params.item,
                    moduleSlug: this.$route.params.moduleSlug,
                    lessonSlug: this.$route.params.lessonSlug
                })
                    .catch(error => {
                        if (error.response.status === 403) {
                            // this.$toasted.error(error.response.data.error.message_key);
                        }
                    })
            }
        }
    },
    computed: {
        ...mapGetters({
            module: 'coursesLesson/module',
            lesson: 'coursesLesson/lesson',
            selectedVideoId: 'coursesLesson/selectedVideoId',
        }),
        activeIndex() {
            if (!this.lesson) return;
            return this.module.materials.data.findIndex(e => e.id === this.lesson.id) + 1;
        },
        activeItem() {
            if (!this.lesson) return;
            return this.module.materials.data.find(e => e.id === this.lesson.id);
        }
    },

    mounted(){
        this.onResize();
    },

    methods: {
        ...mapMutations({
            SET_VIDEO_ID: 'coursesLesson/SET_VIDEO_ID'
        }),

        ...mapActions({
            fetchLesson: 'coursesLesson/FETCH_LESSON'
        }),

        getCamelCase(text) {
            return camelCase(text);
        },

        getMaterialItem(material) {
            const typeMaterial = material.material === 'lesson' ? 'userLesson' : 'userHomeWork';
            return material[typeMaterial].data
        },

        setStatusMaterialItem(item) {
            const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
            return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
        },
        formattedTimeLesson(duration) {
            const minutes = Math.floor(duration / 60);
            const seconds = duration % 60;
            return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
        },
        declensionWord(count) {
            let titles = [this.$t('question1'), this.$t('question2'), this.$t('question3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },

        changeChapter(video, chapter) {
            this.SET_VIDEO_ID(video.id);
            this.$bus.$emit('enter-chapter', {video, chapter})
        },

        onSelectVideo(video) {
            this.SET_VIDEO_ID(video.id);
        },

        getStatus(item) {
            let cnf = null;

            if (item.material === "lesson") {
                cnf = item.userLesson.data;

            } else {
                cnf = item.userHomeWork.data;
            }
            return cnf.status
        },
        formattedTime(time, key = 'default') {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            if (key === 'default') {
                return `${hours < 10 ? '0' + hours : hours} ${this.$t('smHour')} ${minutes < 10 ? '0' + minutes : minutes} ${this.$t('smMinutes')}`
            } else {
                return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:00`
            }
        },
        calculationTimeModule(duration) {
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return `${hours} ${this.$t('smHour')}  ${minutes < 10 ? '0' + minutes : minutes}  ${this.$t('smMinutes')}`
        },
        onResize() {
            this.isMobile = window.innerWidth < 900;            
        }
    }
}
